import { render, staticRenderFns } from "./ResetPasswordLayout.vue?vue&type=template&id=ab11aba8&scoped=true&"
var script = {}
import style0 from "./ResetPasswordLayout.vue?vue&type=style&index=0&id=ab11aba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab11aba8",
  null
  
)

export default component.exports